import URI from "urijs";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AuditLogEntries, AuditLogStatus as AuditLogStatusApi } from "@graylog/enterprise-api";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const urlPrefix = "/plugins/org.graylog.plugins.auditlog";
export const AUDIT_LOG_STATUS_QUERY_KEY = ["auditlog", "status"];
export const AUDIT_LOG_ENTRIES_QUERY_KEY = ["auditlog", "entries"];
export const getAuditLogExportURL = (format, query) => {
  const q = query ? `&query=${query}` : "";
  return new URI(qualifyUrl(`${urlPrefix}/entries/export/${format}?limit=10000${q}`)).toString();
};
const fetchAuditLogStatus = () => AuditLogStatusApi.statusAll().catch((error) => {
  UserNotification.error(
    i18n.t("notifications.status_failed", { ns: "enterprise_auditlog", message: error.message }),
    i18n.t("notifications.status_failed_title", { ns: "enterprise_auditlog" })
  );
  throw error;
});
const fetchAuditLogEntries = ({ page, perPage, query }) => {
  const promise = query ? AuditLogEntries.search({ page, per_page: perPage, query }) : AuditLogEntries.entries(page, perPage);
  return promise.catch((error) => {
    UserNotification.error(
      i18n.t("notifications.entries_failed", { ns: "enterprise_auditlog", message: error.message }),
      i18n.t("notifications.entries_failed_title", { ns: "enterprise_auditlog" })
    );
    throw error;
  });
};
export const useAuditLogStatus = () => useQuery({
  queryKey: AUDIT_LOG_STATUS_QUERY_KEY,
  queryFn: fetchAuditLogStatus,
  retry: false
});
export const useAuditLogEntries = (searchParams) => useQuery({
  queryKey: [...AUDIT_LOG_ENTRIES_QUERY_KEY, searchParams],
  queryFn: () => fetchAuditLogEntries(searchParams),
  placeholderData: keepPreviousData,
  retry: false
});
